// extracted by css-extract-rspack-plugin
export default {"empty-date":"empty-date-fXUU4W","emptyDate":"empty-date-fXUU4W","list":"list-oPEJmX","title":"title-vJSK9Y","value":"value-Xjl_hH","accent":"accent-eD7Qpi","empty":"empty-KUWSwJ"};